import { JobStatusEnum } from '../../models/jobStatusEnum';
import { User } from '../../models/user';
import { combineMongoAndConditions } from './combineMongoAndConditions';
import { getJobFilterParamsMongoQuery } from './getJobFilterParamsMongoQuery';
import { getJobSearchMongoQuery } from './getJobSearchMongoQuery';
import { getJobStateMongoQuery } from './getJobStateMongoQuery';
import {
  JobsMongoQueryOptions,
  MongoSearchQueryParams,
} from './JobsMongoQueryOptions';

export { getJobFilterParamsMongoQuery } from './getJobFilterParamsMongoQuery';
export {
  getJobSearchMongoQuery,
  getMatchingShiftsForSearchText,
} from './getJobSearchMongoQuery';
export { getJobStateMongoQuery } from './getJobStateMongoQuery';
export type {
  JobsMongoQueryOptions,
  MongoSearchQueryParams,
} from './JobsMongoQueryOptions';

export function getJobsMongoQuery(
  queryParams: MongoSearchQueryParams,
  user: User,
  options: JobsMongoQueryOptions = {},
) {
  const {
    showCanceledWithArchived = false,
    showOnlyCanceledJobs = false,
    showOnlyActionRequiredBookableJobs = false,
    showOnlyActionRequiredNoOpenInviteesJobs = false,
    showOnlyBookedJobs = false,
    showUnmappedJobs = false,
    showOnlyUnapprovedHours = false,
    activeSearchType = 'ALL',
    matchingShifts = [],
  } = options;

  const mongo$AndQuery: object[] = [
    ...getJobStateMongoQuery(queryParams.state ?? JobStatusEnum.OPEN, user, {
      showCanceledWithArchived,
      showOnlyCanceledJobs,
      showOnlyActionRequiredBookableJobs,
      showOnlyActionRequiredNoOpenInviteesJobs,
      showOnlyBookedJobs,
      showOnlyUnapprovedHours,
    }),
    ...getJobFilterParamsMongoQuery(queryParams, user),
    ...getJobSearchMongoQuery(
      queryParams,
      user,
      activeSearchType,
      matchingShifts,
    ),
  ];

  if (showUnmappedJobs) {
    mongo$AndQuery.push({
      perigonMappingIncomplete: true,
    });
  }

  return combineMongoAndConditions(mongo$AndQuery);
}
